export { default as Related } from './Related';
export type { RelatedItem } from './Related';
